// extracted by mini-css-extract-plugin
module.exports = {"container":"MenuItem_container__3DK1i","open":"MenuItem_open__1qAvS","disabled":"MenuItem_disabled__1QbNx","overlay":"MenuItem_overlay__2hHs4","show":"MenuItem_show__qalRI"};